'use client'

/**
 * PostPayCard + InvoiceHistoryCard v3 — Bill prototype 2026-05-30 .brow rows.
 * Each row sits on its own line below the credit-balance card. Gradient icon
 * tiles match the prototype: purple (TV-tone) for the post-pay rocket, brand
 * green for the invoice receipt.
 *
 * The PostPayCard's right-side "Schedule a call →" opens Bill's Calendly. The
 * InvoiceHistoryCard's entire row is clickable and opens BudgetHistoryPanel.
 */

import { HugeiconsIcon } from '@hugeicons/react'
import {
  RocketIcon,
  Invoice01Icon,
  ArrowRight01Icon,
} from '@hugeicons-pro/core-stroke-rounded'

const CALENDLY_URL = 'https://calendly.com/bill-atrium/30min'

const POSTPAY_TILE = 'linear-gradient(135deg, #7A5BD6, #B9A6FF)'
const INVOICE_TILE = 'linear-gradient(135deg, #0A8A6E, #2BC39A)'

export function PostPayCard() {
  return (
    <div className="bv3-brow">
      <div className="ic" style={{ background: POSTPAY_TILE }}>
        <HugeiconsIcon icon={RocketIcon} className="size-5" />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 15, fontWeight: 700 }}>
          Pay after-the-fact with monthly invoicing
        </div>
        <div style={{ fontSize: 13, color: '#888', marginTop: 2 }}>
          Schedule a call with our team to set up post-pay billing.
        </div>
      </div>
      <a
        href={CALENDLY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="bv3-btn-out"
        style={{ whiteSpace: 'nowrap', textDecoration: 'none' }}
      >
        Schedule a call
        <HugeiconsIcon icon={ArrowRight01Icon} className="size-4" />
      </a>
    </div>
  )
}

interface InvoiceHistoryCardProps {
  onOpen: () => void
}

export function InvoiceHistoryCard({ onOpen }: InvoiceHistoryCardProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onOpen()
        }
      }}
      className="bv3-brow clickable"
      style={{ marginBottom: 8 }}
    >
      <div className="ic" style={{ background: INVOICE_TILE }}>
        <HugeiconsIcon icon={Invoice01Icon} className="size-5" />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 15, fontWeight: 700 }}>Invoice history</div>
        <div style={{ fontSize: 13, color: '#888', marginTop: 2 }}>Receipts and top-ups</div>
      </div>
      <HugeiconsIcon
        icon={ArrowRight01Icon}
        className="size-[18px]"
        style={{ color: '#aaa' }}
      />
    </div>
  )
}
